import { fetchWithAuth } from "digimaker-ui/util";
import React, { useEffect, useState } from "react";
import { Link, Route, useHistory, useRouteMatch } from "react-router-dom";
import i18n from "eth-common/i18n/i18n";

export const convertHighlighted = (value: any) => {
  if (value) {
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: value
            .split("\u0000")
            .join("<span class='text-danger'>")
            .split("\u0001")
            .join("</span>"),
        }}
      />
    );
  }
  return null;
};

export const getLink = (item: any) => {
  if (item.file) {
    return "/var/" + item.file;
  }
  return item.link;
};

export const AutoSearch = (props: {
  mode: "compact" | "full";
  currentKeyword?: string;
  onChange?: (value: string) => void;
  onSubmit?: () => void;
}) => {
  const { mode, onChange, currentKeyword, onSubmit } = props;
  const [autoResult, setAutoResult] = useState<Record<string, any> | null>(
    null,
  );
  const [tagCount, setTagCount] = useState([]);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    setKeyword(currentKeyword || "");
  }, [currentKeyword]);

  const autoSearch = async (keyword: string) => {
    if (keyword && keyword.length > 2) {
      const result = await fetchWithAuth(
        "/api/eth/search_suggestions?q=" + keyword,
        {
          method: "GET",
        },
      );
      if (result.error === false) {
        setAutoResult(result.data.results);
        setTagCount(result.data.tag_count);
      }
    } else {
      setAutoResult(null);
      setTagCount([]);
    }
  };

  useEffect(() => {
    if (onChange) {
      onChange(keyword);
    }
  }, [keyword, mode]);

  const searchPage = "/ressurssdatabasen";

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    setAutoResult(null);
    setTagCount([]);
  };

  useEffect(() => {
    document.addEventListener("click", handleClick as any);
    return () => {
      document.removeEventListener("click", handleClick as any);
    };
  }, []);

  const history = useHistory();

  return (
    <div>
      <div>
        <form
          className="position-relative"
          onSubmit={(e) => {
            e.preventDefault();
            if (mode !== "compact") {
              if (onSubmit) {
                onSubmit();
              }
            } else {
              history.push(searchPage + "?q=" + keyword);
              setKeyword("");
              if (document.activeElement) {
                (document.activeElement as HTMLElement).blur();
              }
            }
          }}
        >
          <input
            type="text"
            className={
              "form-control" + (mode === "compact" ? " compact-search" : "")
            }
            autoComplete="off"
            name="q"
            style={{
              height: mode === "compact" ? "32px" : "42px",
              background:
                mode === "compact" ? "rgba(255, 255, 255, 0.3)" : "white",
              color: mode === "compact" ? "white" : "#000",
              border:
                mode === "compact"
                  ? "1px solid rgba(255, 255, 255, 0.3)"
                  : "1px solid #eeeeee",
              borderRadius: "0px",
            }}
            placeholder={i18n.t("Type to search")}
            value={keyword}
            onChange={(e) => {
              setKeyword(e.target.value);
              autoSearch(e.target.value);
            }}
          />
          {mode === "compact" && (
            <button
              className="btn btn-sm btn-text"
              type="submit"
              style={{ position: "absolute", right: 0, top: 0, color: "white" }}
            >
              <i className="fa fa-search"></i>
            </button>
          )}
        </form>
      </div>
      <div className="position-relative">
        {tagCount && tagCount.length > 0 && (
          <div
            style={{
              zIndex: 1000,
              maxHeight: "300px",
              width: mode === "compact" ? "400px" : "100%",
              overflowY: "auto",
              right: 0,
              boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
            }}
            className="position-absolute top-0 shadow-md bg-white"
          >
            {tagCount.map((item: any) => (
              <div key={item.id}>
                <div style={{ color: "#000" }} className="p-2 border-bottom">
                  <Link
                    to={
                      searchPage +
                      "?tags=" +
                      item.id +
                      "__" +
                      item.name +
                      "&q=" +
                      keyword
                    }
                    style={{ color: "#000" }}
                  >
                    {item.name}{" "}
                    <span className="text-muted">({item.count})</span>
                  </Link>
                </div>
                {autoResult &&
                  autoResult[item.id + ""] &&
                  Array.isArray(autoResult[item.id + ""]) && (
                    <div className="px-2">
                      {autoResult[item.id + ""].map((item: any) => {
                        const link = getLink(item);
                        return (
                          <a
                            href={link}
                            target="_blank"
                            key={item.id}
                            rel="noopener noreferrer"
                          >
                            <div
                              className="search-result-item"
                              style={{
                                display: "flex",
                                cursor: "pointer",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{ width: "95%" }}
                                className="font-weight-bold text-truncate"
                              >
                                {item.name}
                              </div>

                              <div style={{ width: "5%", textAlign: "right" }}>
                                <i className="fa fa-arrow-right"></i>
                              </div>
                            </div>
                          </a>
                        );
                      })}
                    </div>
                  )}
                {/* <div
                key={item.id}
                
                style={{
                  display: "flex",
                  cursor: "pointer",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "95%" }}>
                  <div className="font-weight-bold text-truncate">
                    {item._name}
                  </div>
                  {item._highlighted && (
                    <div style={{ color: "#666666" }}>
                      {convertHighlighted(item._highlighted.value)}
                    </div>
                  )}
                </div>
                <div style={{ width: "5%", textAlign: "right" }}>
                  <i className="fa fa-arrow-right"></i>
                </div>
              </div> */}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
